import { render, staticRenderFns } from "./web_categories_field.vue?vue&type=template&id=5f048072&lang=pug"
import script from "./web_categories_field.vue?vue&type=script&lang=js"
export * from "./web_categories_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports